<div [class]="'call-to-action-dialog-container'">
  <span class="title">{{ data.title }}</span>
  <span>{{ data.text }}</span>
  <app-button (click)="redirectToAction()" [text]="data.actionText" [theme]="data.theme === 'coaching' ? 'coaching' : 'primary'" [size]="data.size ?? 'md'"></app-button>
  <span *ngIf="!data.hideLogin">Déjà un compte ? <a class="link" (click)="redirectToLogin()">Se connecter</a></span>
</div>
